function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.99957 3.00431L3.99902 6.99662C3.99897 7.39586 4.4438 7.63414 4.77612 7.41288L7.77392 5.41694C8.07109 5.21908 8.07113 4.78251 7.774 4.58461L4.77675 2.58824C4.44449 2.36693 3.99963 2.60509 3.99957 3.00431ZM0 2.25C0 1.00736 1.00736 0 2.25 0H8.75C9.99264 0 11 1.00736 11 2.25V7.75C11 8.99264 9.99264 10 8.75 10H2.25C1.00736 10 0 8.99264 0 7.75V2.25ZM2.25 1C1.55964 1 1 1.55964 1 2.25V7.75C1 8.44036 1.55964 9 2.25 9H8.75C9.44036 9 10 8.44036 10 7.75V2.25C10 1.55964 9.44036 1 8.75 1H2.25ZM2 11.0002C2.4561 11.6074 3.18227 12.0002 4.00018 12.0002H9.25018C11.3213 12.0002 13.0002 10.3213 13.0002 8.25018V4.00018C13.0002 3.18227 12.6074 2.4561 12.0002 2V8.25018C12.0002 9.76897 10.769 11.0002 9.25018 11.0002H2Z",
  fill: "#3E5C69"
});

function SvgAudioCount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioCount);
export default __webpack_public_path__ + "static/media/audio_count.8bce7e65.svg";
export { ForwardRef as ReactComponent };